'use es6';

import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import createBatchedReferenceResolver from 'reference-resolvers/lib/createBatchedReferenceResolver';
import { getInboundDbObjectTypesById, createGetInboundDbObjectTypesById } from 'reference-resolvers/api/InboundDbMetaAPI';
export const createCustomObjectTypeReferenceResolver = options => createBatchedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.CUSTOM_OBJECT_TYPES,
  createFetchByIds: createGetInboundDbObjectTypesById,
  fetchByIds: getInboundDbObjectTypesById
}, options));
export default createCustomObjectTypeReferenceResolver();